import { createAction } from 'typesafe-actions';
import { ErrorState } from '../types';

export const addErrorHandlerAction =
  createAction('add-error-handler')<ErrorState>();

export const clearErrorHandlerAction = createAction('clear-error-handler')();
